import { Component, Input, OnInit } from '@angular/core';
import { MovieFestival } from '@usheru-hff/shared/domain';
import { isDateRangePast, isDateRangePresent } from '@usheru-hff/shared/utils';
/**
 * //TODO docs favio
 * //TODO barbeitoalex propostal - refractor name to something like "movie-festivals"
 * //TODO barbeitoalex propostal - use environment values in their own method and subscribe to environment changes
 * //TODO barbeitoalex propostal - move component folder to the root of components
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-showtime-streaming-at-festivals',
  templateUrl: './showtime-streaming-at-festivals.component.html',
  styleUrls: ['./showtime-streaming-at-festivals.component.scss']
})
export class ShowtimeStreamingAtFestivalsComponent implements OnInit {
  @Input() movieFestivals: MovieFestival[];

  ongoingFestivals: MovieFestival[] = [];
  pastFestivals: MovieFestival[] = [];
  upcomingFestivals: MovieFestival[] = [];
  highlights: MovieFestival[] = [];

  pastfilmsActive = false;

  constructor() {}

  ngOnInit(): void {
    this.classifyFestivals();
    // displaying past films festivals if it is the only option with data
    if (this.ongoingFestivals.length == 0 && this.upcomingFestivals.length == 0 && this.highlights.length == 0) {
      this.pastfilmsActive = true;
    }
  }

  /**
   * It classifies festivals into ongoing, past, upcoming based on the festival edition from an to date
   */
  classifyFestivals() {
    for (const mFestival of this.movieFestivals) {
      const from = mFestival.festivalEdition.dateFrom;
      const to = mFestival.festivalEdition.dateTo;
      if (isDateRangePresent(from, to)) {
        this.ongoingFestivals.push(mFestival);
      } else if (isDateRangePast(from, to)) {
        this.pastFestivals.push(mFestival);
      } else {
        this.upcomingFestivals.push(mFestival);
      }
    }
  }
}
